import ProjectsPage from "@/views/Projects.vue";
import ProjectsList from "@/components/projects/List.vue";
import ProjectsInfo from "@/components/projects/Info.vue";
import ProjectsCreate from "@/components/projects/Create.vue";
import ChatPage from "@/views/Chat.vue";


const projects = [
    {
        path: "/projects",
        component: ProjectsPage,
        children: [
            {
                path: "",
                name: 'ProjectsList',
                component: ProjectsList,
            },
            {
                path: "create",
                name: "ProjectsCreate",
                component: ProjectsCreate,
                props: route => ({ service: route.query.service }),
            },
            {
                path: ":id",
                name: "ProjectsInfo",
                component: ProjectsInfo,
                props: true,
            },
            {
                path: ":id/chat",
                name: "ProjectMessages",
                component: ChatPage,
                props: true,
            },
        ]
    },
];

export default projects;
